"use client";
import { useState as f, useCallback as l } from "react";
import { fileMatchesAccept as k } from "../../../utils/utils.mjs";
const A = (n, h = {}) => {
  const { accept: s, maxSizeBytes: i, onFileSelected: d } = h, [g, t] = f("default"), [p, a] = f(null), [y, c] = f(null), o = l(() => {
    t("default"), a(null), c(null), n.current && (n.current.value = "");
  }, [n]), F = l(() => {
    var e;
    (e = n.current) == null || e.click();
  }, [n]), u = l(
    async (e) => {
      if (s != null && s.length && !k(e, s)) {
        t("error"), c(`Invalid file type. Accepted: ${s.join(", ")}`), a(null);
        return;
      }
      if (i && e.size > i) {
        t("error"), c(`File exceeds maximum size of ${Math.round(i / 1024 / 1024)}MB`), a(null);
        return;
      }
      if (a(e), c(null), d) {
        t("loading");
        try {
          await d(e), t("success");
        } catch (r) {
          t("error"), c(r instanceof Error ? r.message : "An error occurred processing the file");
        }
      } else
        t("success");
    },
    [s, i, d]
  ), x = l(
    async (e) => {
      var m;
      const r = (m = e.target.files) == null ? void 0 : m[0];
      if (!r) {
        o();
        return;
      }
      await u(r);
    },
    [u, o]
  ), S = l(
    async (e) => {
      const r = e[0];
      if (!r) {
        o();
        return;
      }
      await u(r);
    },
    [u, o]
  );
  return { state: g, file: p, error: y, handleChange: x, handleDrop: S, openFilePicker: F, reset: o };
};
export {
  A as useFileInput
};
